<template>
  <div class="maintenance" v-for="maintenance in data" :key="maintenance.id">
    <div class="maintenance__header">
      <div>{{ maintenance.name }}</div>
      <div :class="`typo-small-title maintenance__header-rating maintenance__header-rating--${maintenance.overall_condition_rating}`">
        {{ maintenance.overall_condition_rating }}
      </div>
    </div>
    <div :class="gridClasses">
      <div
        class="maintenance__item"
        v-for="item in maintenance.members"
        :key="item.id"
      >
        <router-link
          :to="{
            name: 'shaftScrollDetail',
            params: {
              elementType: typeStation ? 'stations' : maintenance.element_type,
              memberId: item.id
            },
          }"
        >
          {{ item.name || `Set ${item.set_number}` }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from '@vue/runtime-core';

const props = defineProps({
  data: { type: Array, required: true },
  typeStation: { type: String, required: false, default: null },
});

const gridClasses = computed(() => ({
  'maintenance__items': true,
  'maintenance__items--large': props.typeStation,
}));
</script>

<style lang="scss" scoped>
@import '@/stylesheets/global';

.maintenance {

  &:not(:last-child) {
    border-bottom: 1px solid map-get($background-color, default);
    padding-bottom: bu(1.5);
  }

  &__header {
    display: flex;
    font-weight: 500;
    justify-content: space-between;
    padding: bu(1) 0;
  }

  &__header-rating {
    align-items: center;
    border-radius: map-get($border-radius, heavy);
    display: flex;
    font-weight: 500;
    height: rem(23);
    justify-content: center;
    width: rem(23);

    @each $rating, $color in $condition-rating-color {
      &--#{$rating} {
        background-color: map-get($color, default);
      }
    }
  }

  .maintenance__items {
    display: grid;
    gap: bu(0.75);
    grid-template-columns: repeat(4, 1fr);
  }

  .maintenance__items--large {
    display: grid;
    gap: bu(0.75);
    grid-template-columns: repeat(3, bu(12.25));
  }

  .maintenance__item {
    @include text-overflow;
    border-radius: 4px;
    border: 1px solid map-get($error-color, default);
    padding: bu(0.25) bu(0.75);
    text-align: center;
  }
}
</style>
